import { AxiosRequestConfig, AxiosResponse } from 'axios'
import createAPIClient from '../services/apiClient'
import { AlertNotified, AlertQuery, PrometheusAlert } from '../types'
import { AlertSensor } from '../types/Alerts'
const api = createAPIClient('/v2')

export async function getAlerts(
  query: AlertQuery = {},
  config?: AxiosRequestConfig
): Promise<PrometheusAlert[]> {
  const response = await api.get('/alerts', {
    ...config,
    params: query
  })

  return response.data
}

type AlertNotifiedQuery = {
  type?: AlertSensor
  device: string
}

export async function getAlertNotified(
  query: AlertNotifiedQuery,
  config?: AxiosRequestConfig
): Promise<AlertNotified> {
  const response: AxiosResponse<AlertNotified> = await api.get(`/alerts/notified`, {
    ...config,
    params: {
      ...query
    }
  })

  return response.data
}

export async function clearAlertNotified(
  query: AlertNotifiedQuery,
  config?: AxiosRequestConfig
): Promise<AlertNotified> {
  const response: AxiosResponse<AlertNotified> = await api.post(
    `/alerts/clear`,
    {},
    {
      ...config,
      params: {
        ...query
      }
    }
  )

  return response.data
}
